import { SpecialSpan } from '@gassan-ui'
import { Article_article } from '@graphql/__generated__/Article'
import React, { FC } from 'react'
import { formatPrice } from '@lib/formatPrice'

const Price: FC<Article_article> = props => {
  const formattedPrice = formatPrice(props.price, true)
  return props.isPriceVisible ? (
    <>
      {props.salePrice && (
        <SpecialSpan
          as="div"
          variant="two"
          display="block"
          mt={{ _: '0.5rem', small: '1rem', large: '1.25rem' }}
          style={{ textDecoration: 'line-through' }}
        >
          {formattedPrice}
        </SpecialSpan>
      )}
      <SpecialSpan
        as="div"
        variant="one"
        display="block"
        mt={{ _: '0.5rem', small: '1rem', large: '1.25rem' }}
        color={props.isOutOfCollection ? 'shades.500' : 'shades.800'}
      >
        {props.salePrice ? formatPrice(props.salePrice, true) : formattedPrice}
      </SpecialSpan>
    </>
  ) : null
}

export default Price
